import { Injectable, OnInit, Provider, QueryList } from '@angular/core';
import { Headers, Http, Response, URLSearchParams, RequestOptions, RequestMethod, ResponseContentType } from '@angular/http';
import { Route, Router, CanLoad, CanDeactivate, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Resolve } from '@angular/router';

import { LocalStorageService } from 'angular-2-local-storage';
import sweetalert2, { SweetAlertOptions } from 'sweetalert2';
import { Observable, AsyncSubject, Subject } from 'rxjs';
// import { AsyncSubject } from 'rxjs/subject/AsyncSubject';
import { TranslateService } from '@ngx-translate/core';

import {
  IApiResult, IDataAccountManager, IDataCompanyLayout, IDataPublisherManager,
  IDataAdvertiserManager, IGATrackerEventConfig, IGTMPayload, PermissionCheck, IDataCompanyManager, IDataDirectopubConfig, IDataExtendedGuestSession
} from './interface';
import {
  Permission, FormElementBase, FormInput, EntitySetting
} from './classes';
import { AppConfig } from '../app.config';

import * as _ from 'lodash';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { CdnBaseURL } from './pipe';
import { FormControl, Validators, FormGroup, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Md5 } from 'ts-md5';
import * as CryptoJS from 'crypto-js';
import { Search } from 'angular2-multiselect-dropdown/lib/menu-item';
import { AppAdvertisingType, UserRole, UserRoleType } from './type';
import { Role, RoleType, ApiEnv } from './enum';
import { updateExpressionWithTypeArguments } from 'typescript';

// tslint:disable: max-classes-per-file
// tslint:disable: member-access

export enum API_SERVICE {
  COUNTRY = 1,
  TIMEZONE,
  EXCHANGE,
  CARRIER,
  OS,
  OS_VERSION,
}

@Injectable()
export class ApiService {
  private baseUrl: string = '/api/';
  constructor(
    private _http: HttpClient,
    private _storageService: LocalStorageService,
    public router: Router
  ) {
    // console.log('ApiService service loaded!');
  }

  ////////// PUBLIC METHODS /////////
  public buildURL(path: string, id?: number | string): string {
    if (!/^\/api\//.test(path)) { path = this.baseUrl.concat(path); }
    if (id) { path = path.concat('/', id.toString(), '/'); }
    return path;
  }

  public request(opts: RequestOptions): Observable<IApiResult> {
    return this._call(opts.url, opts);
  }

  public get(path: string, id?: number | string, query?: URLSearchParams): Observable<IApiResult> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Get,
      search: query || new URLSearchParams(),
    });
    return this._call(this.buildURL(path, id), requestOpts);
  }

  public getExtService(path: string): Observable<any> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Get
    });
    return this._call(path, requestOpts);
  }

  public post(path: string, body: any): Observable<IApiResult> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Post,
      body,
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    return this._call(this.buildURL(path), requestOpts);
  }

  public delete(path: string, id?: number | string, body?: any): Observable<IApiResult> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Delete,
      body,
    });
    return this._call(this.buildURL(path, id), requestOpts);
  }

  public put(path: string, id?: number | string, body?: any): Observable<IApiResult> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Put,
      body,
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    return this._call(this.buildURL(path, id), requestOpts);
  }

  public patch(path: string, body: any): Observable<IApiResult> {
    const requestOpts = new RequestOptions({
      method: RequestMethod.Patch,
      body,
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    return this._call(this.buildURL(path), requestOpts);
  }

  ////////// PRIVATE METHODS /////////
  private _call(url: string, opt: RequestOptions): Observable<IApiResult> {
    const authToken = this._storageService.get<string>('auth-token');
    const xTesterUser = this._storageService.get<string>('x-tester-user');
    const xAdvertiserImpersonate = this._storageService.get<string>('x-advertiser-impersonate');

    // create a new instance of headers if not isset
    if (!(opt.headers instanceof Headers)) { opt.headers = new Headers(); }
    // create a new instance of query object if not isset
    if (!(opt.search instanceof URLSearchParams)) { opt.search = new URLSearchParams(); }

    if (authToken) {
      opt.search.set('token', authToken); // pass token over the querystring
      opt.headers.append('X-Auth-Token', authToken); // pass token over the x-auth-token header
    }
    if (xTesterUser) {
      opt.headers.append('X-Tester-User', xTesterUser); // pass token over the x-auth-token header
    }
    if (xAdvertiserImpersonate) {
      opt.headers.append('X-Advertiser-Impersonate', xAdvertiserImpersonate);
    }

    opt.headers.append('Accept', 'application/json');
    opt.responseType = ResponseContentType.Json;
    // in case of url passed over the options
    if (!url) { url = opt.url; }

    const method = (() => {
      switch (opt.method) {
        case RequestMethod.Delete: return 'DELETE';
        case RequestMethod.Head: return 'HEAD';
        case RequestMethod.Options: return 'OPTIONS';
        case RequestMethod.Patch: return 'PATCH';
        case RequestMethod.Post: return 'POST';
        case RequestMethod.Put: return 'PUT';
        case RequestMethod.Get:
        default: return 'GET';
      }
    })();

    if (!!opt.body && /^(post|put|patch)$/i.test(method)) {
      if (_.isString(opt.body)) {
        opt.body = JSON.parse(opt.body);
      }
      opt.headers.append('Content-Type', 'application/json');
    }

    return this._http.request<IApiResult>(method, url || opt.url, {
      body: opt.body,
      // headers: (() => {
      //   let h = new HttpHeaders();
      //   if (opt.headers instanceof Headers) {
      //     // tslint:disable-next-line:forin
      //     for (const k in opt.headers.keys()) {
      //       h.set(k, opt.headers.get(k));
      //     }
      //   }
      //   return h;
      // })(),
      headers: (() => new HttpHeaders(_.reduce(opt.headers.keys(), (h, k) => _.assign({}, h, { [k]: opt.headers.get(k) }), {})))(),
      responseType: 'json',
      params: (() => {
        let p = new HttpParams();
        if (opt.search instanceof URLSearchParams) {
          opt.search.paramsMap.forEach((v, k) => {
            p = p.set(k, v[0]);
          });
        }
        return p;
      })()
      // observe: 'response',
      // reportProgress: boolean,
      //  withCredentials: true,
    })
      .catch(this._handleError);
  }
  private _handleError(errorResponse: HttpErrorResponse) {
    const res: IApiResult = errorResponse.error;
    const errMsg: string = `${errorResponse.status} - ${errorResponse.statusText || ''} ${res.message}`;
    console.error(errMsg);
    if (res.error !== 0 && /^(Token_Expired|Invalid_Token|Down_Maintenance)$/i.test(res.code)) { // logout in case of token expired
      if (/^(Down_Maintenance)$/i.test(res.code)) {
        // localStorage.setItem('app.x-tester-user', JSON.stringify('qa')), setTimeout(function(){localStorage.removeItem('app.x-tester-user')}, 1000 * 60 * 60); // 1 hour left
        console.warn(res.message);
        const errURL = '/error/'.concat(String(res.error));
        if (window.location.pathname !== errURL) {
          window.location.href = errURL;
        }
      } else {
        console.warn('Token expired or Invalid! redirecting to the login page');
        SharedService.getInstance().logout();
        // window.location.href = '/login';
      }
    }
    return Observable.throw(res || errMsg);
  }

}

export interface IAlertServiceOptions extends SweetAlertOptions {
  translation?: { [name: string]: string | number };
}

@Injectable()
export class Select2Service {
  constructor(
    public api: ApiService
  ) { }

  getData(term: string = null, path: string, offset: any, limit: any): Observable<any[]> {
    const params = new URLSearchParams();
    if (term) {
      params.set('search', '*' + term + '*');
      params.set('search_field', 'name');
      params.set('search_condition', 'OR');
    }
    params.set('filter', 'name,id');
    params.set('limit', limit);
    params.set('offset', offset);
    return this.api.get(path, '', params).map((r: any) => r);
  }
}

// tslint:disable-next-line: max-classes-per-file
@Injectable()
export class AlertService {
  constructor(
    public translate: TranslateService
  ) { }

  public success(opts: IAlertServiceOptions): Promise<any> {
    return this._show(Object.assign(opts, { type: 'success' }));
  }
  public warning(opts: IAlertServiceOptions): Promise<any> {
    return this._show(Object.assign(opts, { type: 'warning' }));
  }
  public error(opts: IAlertServiceOptions): Promise<any> {
    return this._show(Object.assign(opts, { type: 'error' }));
  }
  public info(opts: IAlertServiceOptions): Promise<any> {
    return this._show(Object.assign(opts, { type: 'info' }));
  }
  public question(opts: IAlertServiceOptions): Promise<any> {
    return this._show(Object.assign(opts, { type: 'question' }));
  }


  private _show(opts: IAlertServiceOptions): Promise<any> {
    opts.buttonsStyling = false;

    const btnRegex = /btn\-(outline\-)?(primary|warning|danger|success|secondary|info|dark|inverse|secondary)/;
    opts.confirmButtonClass = `btn ${btnRegex.test(opts.confirmButtonClass) ? '' : 'btn-success'} ${opts.confirmButtonClass || ''}`;
    opts.cancelButtonClass = `btn ${btnRegex.test(opts.cancelButtonClass) ? '' : 'btn-danger'} ${opts.cancelButtonClass || ''}`;

    const translationFields: Array<{ key: string, value: string }> = [];
    for (const key in opts) {
      if (!/((confirm|cancel)ButtonText|html|text|title(Text)?|inputPlaceholder)/.test(key)) { continue; }
      if (opts[key] && opts[key].length > 0) { translationFields.push({ key, value: opts[key] }); }
    }

    return this.translate.get(translationFields.map((t) => t.value), opts.translation || {})
      .toPromise()
      .then((r) => {
        // tslint:disable-next-line:forin
        for (const i in r) {
          const index = translationFields.findIndex((t) => t.value === i);
          if (index !== -1) { opts[translationFields[index].key] = r[i]; }
        }

        delete opts.translation;
        return sweetalert2(opts);
      });

  }

}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class SharedService {

  public environment: ApiEnv = 1;
  public static getInstance(router?, storageService?, api?, translate?) {
    if (SharedService._instance === null && router && storageService && api && translate) {
      SharedService._instance = new SharedService(router, storageService, api, translate);
    }
    return SharedService._instance;
  }

  private static _instance: SharedService = null;
  private _container: {
    [name: string]: any;
  } = {};

  constructor(
    public router: Router, 
    public storageService: LocalStorageService, 
    public api: ApiService, 
    public translate: TranslateService) {
    // console.log('SharedService service loaded!');
  }

  public isProduction(){
    return this.environment === ApiEnv.Production;
  }  

  public set(name: string, val: any): SharedService {
    this._container[name] = val;
    return this;
  }
  public get<T>(name: string): T {
    return this._container[name];
  }
  public clearAll() {
    this._container = {};
    if (this.storageService) { this.storageService.remove('redir-path', 'redir-search'); }
  }

  public clone<T>(entry): T {
    return JSON.parse(JSON.stringify(entry));
  }

  public getUserRoleByID(roleID: Role): UserRole {
    switch (roleID) {
      case Role.angelOrGod: return 'admin';
      case Role.member: return 'member';
      case Role.advertiser: return 'advertiser';
      case Role.publisher: return 'publisher';
      case Role.api: return 'api';
      case Role.angel: return 'admin_assistant';
      case Role.exchange: return 'exchange';
      default: return null;
    }
  }
  public getUserRoleTypeByID(userRoleTypeId: RoleType): UserRoleType {
    switch (userRoleTypeId) {
      case RoleType.AdvertiserManager: return 'advertiser_manager';
      case RoleType.PublisherManager: return 'publisher_manager';
      case RoleType.AdvertiserAffiliation: return 'advertiser_affiliation';
      case RoleType.GuestManager: return 'guest_manager';
      case RoleType.Guest: return 'guest';
      default: return null;
    }
  }

  public getApiServicePathFromID(serviceID: API_SERVICE): string {
    switch (serviceID) {
      case API_SERVICE.COUNTRY: return 'country';
      case API_SERVICE.TIMEZONE: return 'timezone';
      case API_SERVICE.EXCHANGE: return 'exchange';
      case API_SERVICE.CARRIER: return 'carrier';
      case API_SERVICE.OS: return 'operating-system';
      case API_SERVICE.OS_VERSION: return 'operating-system-version';
      default: return null;
    }
  }

  public loadAppIcons() {
    // tslint:disable-next-line:one-variable-per-declaration
    const iconURL = new CdnBaseURL().transform(this.layout.favicon.location), iconMimeType = this.layout.favicon.mime;

    // if (jQuery('link[rel="apple-touch-icon"]').length === 0) {
    //   for (const sz of ['57x57', '60x60', '72x72', '76x76', '114x114', '120x120', '144x144', '152x152', '180x180']) {
    //     const $iconEl = jQuery('<link>').attr('rel', 'apple-touch-icon').attr('sizes', sz).attr('href', iconURL);
    //     if (iconMimeType) { $iconEl.attr('type', iconMimeType); }
    //     jQuery('head').append($iconEl);
    //   }
    // }
    if (jQuery('link[rel="icon"]').length === 0) {
      for (const sz of ['16x16', /*'32x32', '96x96', '192x192'*/]) {
        const $iconEl = jQuery('<link>').attr('rel', 'icon')/*.attr('sizes', sz)*/.attr('href', iconURL);
        if (iconMimeType) { $iconEl.attr('type', iconMimeType); }
        jQuery('head').append($iconEl);
      }
    }
    // if (jQuery('meta[name=msapplication-TileImage]').length === 0) {
    //   jQuery('head').append(jQuery('<meta>').attr('name', 'msapplication-TileColor').attr('content', '#00bcd4'));
    //   jQuery('head').append(jQuery('<meta>').attr('name', 'msapplication-TileImage').attr('content', iconURL));
    //   jQuery('head').append(jQuery('<meta>').attr('name', 'theme-color').attr('content', '#00bcd4'));
    // }
  }

  public loadGuestUserSession() {
    // const [username, password] = _.get(this.directopubConfig, 'guest.manager', '').split(':');
    // console.log('loading guest manager "%s" ...', guestManager)
    if (_.isUndefined(this.guest)) {
      this.guest = null;
      const identifier = ['guest', 'manager', this.layout.uid];
      const session = _.get(this.guest, 'session.token', undefined);
      return this.api.post('ext/guest-session-mgr', { identifier, session })
        .toPromise()
        .then((r: IApiResult) => {
          [this.guest] = r.data.length > 0 ? r.data : [null];
          // console.log('result>>>', r)
          if (!this.guest) {
            if ((['guest', 'guest_manager'] as UserRoleType[]).indexOf(this.storageService.get<UserRoleType>('user-role-type')) > -1) {
              this.storageService.clearAll();
            }
            return;
          }
          if (this.getUserRoleTypeByID(this.guest.user_role_type_id) === this.storageService.get<UserRoleType>('user-role-type')) {
            this.storageService.set('auth-token', this.guest.token);
          }
          return this.guest;
        }, () => null);
    }
    return Observable.of(null).toPromise();
  }
  public get haveGuestSessionActive(): boolean {
    const { account, company } = this;
    const r = this.guest &&
      (
        this.guest.token === this.storageService.get<string>('auth-token') ||
        this.getUserRoleTypeByID(this.guest.user_role_type_id) === this.storageService.get<UserRoleType>('user-role-type')
      );
    if (this.guest && (!account || !company)) { this.setupGuestSession(); }
    return r;
  }
  public get haveGuestAdvertiserSession() {
    const { role_type } = _.get(this, 'account', {} as any);
    return role_type === 'guest';
  }
  public setupGuestSession() {
    if (!this.guest) { return; }
    if ((['guest_manager', 'guest'] as UserRoleType[]).indexOf(this.storageService.get<UserRoleType>('user-role-type')) > -1) {
      this.storageService.clearAll();
    }
    this.storageService.set('auth-token', this.guest.token);
    this.storageService.set('company-uid', this.guest.company_uid);
    this.storageService.set('user-role', /* 'advertiser' */this.getUserRoleByID(this.guest.user_role_id));
    this.storageService.set('user-role-type', this.getUserRoleTypeByID(this.guest.user_role_type_id));
    this.storageService.set('auth-expire-time', new Date(this.guest.expiration).getTime());
    this.account = {
      name: 'Guest', surname: 'Manager', id: this.guest.user_id, company_name: this.layout.company_name,
      role: /* 'advertiser' */ this.getUserRoleByID(this.guest.user_role_id),
      role_type: this.getUserRoleTypeByID(this.guest.user_role_type_id)
    };
    this.company = { name: this.layout.company_name } as IDataCompanyManager;
    this.advertiser = { name: this.layout.company_name, id: -1000 } as IDataAdvertiserManager;
  }

  public getPasswordAge() {
    
    let account_id = this.account.id

    return this.api.get('account/password-age', account_id ).map(
      a => {        
        let acc = a.data        
        this.account.password_age = acc.password_age
        this.account.password_expired = acc.password_expired    
      }
    ).toPromise()

  }

  public loadPermissions(permissionMap: { [name: string]: string[] }): { [name: string]: Permission } {
    if (!this.account) {
      console.warn('Permissions can\'t be loaded without info of account');
      return;
    }

    const permissionsList: { [name: string]: Permission } = {};
    this.account.permission.map((p) => {
      if (permissionMap && permissionMap[p.name]) {
        permissionMap[p.name].map((perm) => {
          permissionsList[perm] = new Permission({
            readable: (p.type && (p.type === 'R' || p.type === 'RW')),
            writable: (p.type && p.type === 'RW')
          });
        });
      }
      // TODO: manage also custom permissions based on type of user
    });
    this.permission = permissionsList;
    // console.log('this.permission', this.permission);
    return this.permission;
  }

  public logout() {
    // debugger;
    const redirect = _.get(this, 'directopubConfig.login.unauthorized_redirect', '/login');
    
    const clear = () => {
      // this.clearAll();
      this.storageService.clearAll();
      setTimeout(() => {        
        window.location.href = redirect;
      },100);
    }    

    if ( this.storageService.get('auth-token') ) {
      this.api.delete('session/manager').toPromise()   
        .then( 
          () => console.info('Successfully logged out'),
          err => console.warn('Logout error', err.message)
        )
        .then( 
          () => clear() 
        )
    } else {
      clear()
    }
    
  }

  public get isUnderDevelopment() { return ENV === 'development'; }

  public readCookie(name: string): string {
    // tslint:disable-next-line:one-variable-per-declaration
    const regex = new RegExp('^'.concat(name, '=(.*)$')),
      cookiefound = decodeURIComponent(document.cookie)
        .split(';')
        .find((cookie) => regex.test(cookie.trim()));
    return cookiefound ? String(cookiefound).trim().replace(regex, '$1') : '';
  }

  public getServiceApiData<T>(type: API_SERVICE): Promise<T[]> {
    let offset = 0;
    // tslint:disable-next-line: one-variable-per-declaration
    const
      servicePath = this.getApiServicePathFromID(type),
      serviceKey = `api.service.${servicePath}`,
      limit = 1000,
      data = [],
      options = new RequestOptions({
        url: this.api.buildURL(`service/${servicePath}`),
        method: RequestMethod.Get,
        responseType: ResponseContentType.Json,
        search: new URLSearchParams()
      }),
      fnApiRecursiveRequest = () => {
        options.search.set('limit', limit.toString());
        options.search.set('offset', offset.toString());
        return this.api.request(options)
          .toPromise()
          .then((r) => {
            data.push.apply(data, r.data);
            if (r.data.length < limit) { return data; }
            offset = offset + limit;
            return fnApiRecursiveRequest();
          });
      };

    // case of data already exists
    if (this.get<T[]>(serviceKey)) { return Observable.of(this.get<T[]>(serviceKey)).toPromise(); }
    if (servicePath && options.url) { // case of url defined
      return fnApiRecursiveRequest().then((r: T[]) => {
        this.set(serviceKey, r); // save service data
        return r;
      });
    }
    console.warn(`Api type id=${type} not defined on API_SERVICE enum`);
    return Observable.of([]).toPromise();
  }

  get currency() {
    // return 'EUR';
    return this.account && this.company ? (this.account.role === 'advertiser' ? this.advertiser.currency_iso_code : this.company.currency_iso_code) : 'USD';
  }

  // i18n
  get language(): string {
    // tslint:disable-next-line: one-variable-per-declaration
    const languages = this.translate.getLangs(),
      browserCultureLang = this.translate.getBrowserCultureLang(),
      browserLang = this.translate.getBrowserLang(),
      selectedLang = this.storageService.get<string>('i18n-lang');

    if (selectedLang && languages.indexOf(selectedLang) > -1) {
      return selectedLang;
    } else if (browserCultureLang && languages.indexOf(browserCultureLang) > -1) {
      return browserCultureLang;
    } else if (browserLang && languages.indexOf(browserLang) > -1) {
      return browserLang;
    }
    return this.translate.defaultLang || 'en';
  }
  set language(language: string) {
    if (!language) { language = this.language; }
    const languages = this.translate.getLangs();
    if (languages.indexOf(language) > -1) {
      this.translate.use(language)
        .subscribe((translations) => {
          if (!!translations) {
            console.debug(`language final loaded "${language}"`, _.cloneDeep(translations));
            this.storageService.set('i18n-lang', language);
          }
        });
    }
  }

  get s3cK3y() {
    const s3cK3y: { passphrase, iterations, salt, iv, saltHex?, ivHex?} = {
      passphrase: new Md5().appendStr(`D1R3CT0PUB.${new Md5().appendStr(VERSION.full).end()}`).end() as string,
      iterations: 999,
      salt: CryptoJS.lib.WordArray.random(256),
      iv: CryptoJS.lib.WordArray.random(16)
    };

    s3cK3y.saltHex = CryptoJS.enc.Hex.stringify(s3cK3y.salt);
    s3cK3y.ivHex = CryptoJS.enc.Hex.stringify(s3cK3y.iv);

    return s3cK3y;
  }

  get guest(): IDataExtendedGuestSession {
    return this.get<IDataExtendedGuestSession>('guest');
  }
  set guest(val: IDataExtendedGuestSession) {
    this.set('guest', val);
  }

  // getter/setter for company layout
  get layout(): IDataCompanyLayout {
    return this.get<IDataCompanyLayout>('layout');
  }
  set layout(val: IDataCompanyLayout) {
    this.set('layout', val);
  }

  // getter/setter for ag-grid language
  get agGridLanguage() {
    return this.get('agGridLanguage')
  }
  set agGridLanguage(val) {
    this.set('agGridLanguage',val)
  }

  // getter/setter for company layout
  get directopubConfig(): IDataDirectopubConfig {
    return this.get<IDataDirectopubConfig>('directopub-config');
  }
  set directopubConfig(val: IDataDirectopubConfig) {
    this.set('directopub-config', val);
  }

  get advertisingType(): AppAdvertisingType {
    // _.get(this.sharedService, 'directopubConfig.app.advertising', 'display' as AppAdvertisingType)
    const acceptable: AppAdvertisingType[] = ['print', 'display', 'both'];
    if (this.directopubConfig && this.account) {
      // if (ENV === 'development') {
      //   this.directopubConfig.app.advertising = [{ type: 'print', role: ['member'] }, { type: 'display' }];
      // }
      const { app } = this.directopubConfig;
      const { role } = this.account;
      const conf = app && app.advertising ? app.advertising : 'display';
      const isValidRole = (advertisingConf: { type: AppAdvertisingType, role?: UserRole[]; member?: number[]; advertiser?: number[] }) => {
        if (_.isArray(advertisingConf.role) && advertisingConf.role.length > 0 && advertisingConf.role.indexOf(role) < 0) { return false; }
        const entityID = (() => {
          switch (role) {
            case 'member': return this.account.id;
            case 'advertiser': return this.advertiser.id;
          }
        })();
        // console.log(advertisingConf,role);
        return _.isUndefined(advertisingConf[role]) || advertisingConf[role].lenght === 0 || advertisingConf[role].indexOf(entityID) > -1;
      };
      if (Array.isArray(conf)) {
        const types = conf
          // filter  only valid types and role checks passed
          // .filter((v) => acceptable.indexOf(v.type) > -1 && ((v.role || []).length === 0 || v.role.indexOf(role) > -1))
          .filter((v) => acceptable.indexOf(v.type) > -1 && isValidRole(v))
          .map((v) => v.type); // transform to array of strings
        switch (types.length) {
          case 0: return 'display';
          case 1: return types[0];
          default: return ((types.indexOf('display') > -1 && types.indexOf('print')) > -1 || types.indexOf('both') > -1) ? 'both' : 'display';
        }
      } else if (_.isString(conf) && acceptable.indexOf(conf) > -1) {
        return conf as AppAdvertisingType;
      }
    }
    return 'display';
  }

  // getter/setter for company manager
  get company(): IDataCompanyManager {
    return this.get<IDataCompanyManager>('company');
  }
  set company(val: IDataCompanyManager) {
    // if (!_.isEmpty(val)) { val.currency_iso_code = 'JPY'; }
    this.set('company', val);
  }

  // getter/setter for account manager
  get account(): IDataAccountManager {
    return this.get<IDataAccountManager>('account');
  }
  set account(val: IDataAccountManager) {
    this.set('account', val);
  }

  // getter/setter for publisher manager
  get publisher(): IDataPublisherManager {
    return this.get<IDataPublisherManager>('publisher');
  }
  set publisher(val: IDataPublisherManager) {
    this.set('publisher', val);
  }

  // getter/setter for publisher manager
  get advertiser(): IDataAdvertiserManager {
    return this.get<IDataAdvertiserManager>('advertiser');
  }
  set advertiser(val: IDataAdvertiserManager) {
    // if (!_.isEmpty(val)) { val.currency_iso_code = 'JPY'; }
    this.set('advertiser', val);
  }

  // getter/setter for permissions
  get permission(): { [name: string]: Permission } {
    return this.get<{ [name: string]: Permission }>('permission');
  }
  set permission(val: { [name: string]: Permission }) {
    this.set('permission', val);
  }
}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class AuthGuard implements CanLoad, CanActivate, CanActivateChild {
  public appConfig;
  constructor(
    private _api: ApiService,
    private _storageService: LocalStorageService,
    public sharedService: SharedService,
    public router: Router,
    private route: ActivatedRoute,
    // public http: Http,
    public http: HttpClient,
    appConfig: AppConfig
  ) {
    this.appConfig = appConfig.getConfig();
  }

  public canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    console.log('AuthGuard loading %s...', route.path);
    return this.isLoggedIn()
      .then((isAuthorized) => {
        const { advertisingType, directopubConfig } = this.sharedService;
        // console.log('isAuthorized',advertisingType, directopubConfig)
        if (isAuthorized) {
          switch (route.path) {
            case 'sponsorship': isAuthorized = (['both', 'print'] as AppAdvertisingType[]).indexOf(advertisingType) > -1; break;
            case 'campaigns': isAuthorized = (['both', 'display'] as AppAdvertisingType[]).indexOf(advertisingType) > -1; break;
            case 'brands': isAuthorized = directopubConfig.advertiser_brands === true; break
          }
          if (!isAuthorized) { this.router.navigate(['/dashboard']); }

          // console.log('PASSWORD EXP', this.sharedService.account.password_expired, this.sharedService.account.password_age)
          // if (this.sharedService.account.password_expired) { this.router.navigate(['/profile'])}

        } else {
          if (this.sharedService.guest) {
            isAuthorized = true;
            this.sharedService.haveGuestSessionActive;
            const queryParams = {};
            if (!/^(howto|profile)/.test(route.path)) {
              /* if (this.route['_routerState'].snapshot.url === '/sponsorship/add') {
                // window.location.href = '/sponsorship/add';
                _.assign(queryParams, { '_': Date.now() });
              } */
              this.router.navigate(['/sponsorship/add'], { queryParams })
              
            } else {
              switch (route.path) {
                case 'profile': this.router.navigate(['/profile/contract']); break;
              }
            }
            return isAuthorized;
          }
          else {
            this.sharedService.logout();
            // this.router.navigate(['/login']); 
          }
          // console.log('not authorized!!');
        }
        return isAuthorized;
      });

  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.isLoggedIn();
  }

  public isLoggedIn(): Promise<boolean> {
    const authToken: string = this._storageService.get<string>('auth-token');
    const authExpireTime: number = this._storageService.get<number>('auth-expire-time');

    //check for guest session
    if (_.get(this.sharedService, 'guest.token') === authToken) {
      return Observable.of(false).toPromise(); // force login failure
    }


    if (!authToken || authToken.length === 0) {
      console.warn('Client token is not defined!');
      return Observable.of(false).toPromise();
    }

    if (!authExpireTime || authExpireTime <= (new Date()).getTime()) {
      return this._api.get('session/manager')
        .toPromise()
        .then((res) => {
          if (res.error === 0 && res.data[0].token && res.data[0].expiration) { this._storageService.set('auth-expire-time', (new Date(res.data[0].expiration)).getTime()); }
          return this.loadSharedData();
        })
        .catch((error) => {
          console.warn('No session active found!');
          return false;
        });
    }
    return this.loadSharedData();
  }

  public loadSharedData(overrideData?: { account?, layout?, publisher?, advertiser?}): Promise<boolean> {
    // debugger
    // tslint:disable-next-line: one-variable-per-declaration
    const
      currentUserRole = this._storageService.get<UserRole>('user-role'),
      currentUserRoleType = this._storageService.get<UserRoleType>('user-role-type'),
      currentUserID = this._storageService.get<number>('user-id'),
      currentRoleEntityID = this._storageService.get<number>(`${currentUserRole}-id`)
      ;
    if (overrideData) {
      this.sharedService.account = overrideData.account || this.sharedService.account;
      this.sharedService.layout = overrideData.layout || this.sharedService.layout;
      this.sharedService[currentUserRole] = overrideData[currentUserRole] || this.sharedService[currentUserRole];
    }

    if (this.sharedService.account && this.sharedService.layout && this.sharedService[currentUserRole]) { return Observable.of(true).toPromise(); }
    return Observable.forkJoin([
      // account info
      this.sharedService.account ? Observable.of(this.sharedService.account) :
        this._api.get('account/manager', currentUserID, (() => { const search = new URLSearchParams(); search.set('permissions', '1'); return search; })()).map((r) => r.data[0]),

      // company info
      this.sharedService.company ? Observable.of(this.sharedService.company) : this._api.get('company/manager').map((r) => r.data[0]),

      // company layout settings
      this.sharedService.layout ? Observable.of(this.sharedService.layout) : this._api.get('company/layout').map((r) => r.data[0]),

      // get details in case of advertiser, null in otherwise
      currentUserRole === 'advertiser' ?
        (this.sharedService[currentUserRole] ? Observable.of(this.sharedService[currentUserRole]) : this._api.get(`${currentUserRole}/manager`, currentRoleEntityID).map((r) => r.data[0])) :
        Observable.of(null),

      // getting role permissions
      (/* !this.sharedService.permission ? this._api.get('ext/permission', currentUserRole).map((r) => r.data[0]) : */ Observable.of(null)),
    ])
      .toPromise()
      .then((data: any[]) => {
        // console.log('responses ', _.cloneDeep(data))
        this.sharedService.account = data.shift(); // getting account response
        this.sharedService.company = data.shift(); // getting company response
        this.sharedService.layout = data.shift(); // getting layout response
        this.sharedService[currentUserRole] = data.shift(); // getting role entity response
        const perms = data.shift();
        if (!_.isNull(perms)) { this.sharedService.loadPermissions(perms); }// load permissions from mock-data permissions map
        if (this.sharedService.layout) {
          this.sharedService.loadAppIcons();
        } else {
          this.sharedService.layout = this.appConfig.default_layout;
        }

        if (!this.sharedService.directopubConfig) {
          const entity = new EntitySetting('company', this.sharedService.layout.uid);
          return this._api.get('entitymanager', null, new URLSearchParams(`api=entity&key=${entity.getKey('env_directopub')}`))
            .map((r) => r.data[0])
            .toPromise()
            .then((r) => {
              try {
                this.sharedService.directopubConfig = r ? r.entity : JSON.parse(this.sharedService.layout.setting_last_collected_note);
              } catch (error) {
                this.sharedService.directopubConfig = {} as IDataDirectopubConfig;
              }
              return true;
            });
        }
        return true;
      });
  }
}
// tslint:disable-next-line: max-classes-per-file
@Injectable()
export class PermissionService implements CanActivate, CanActivateChild {
  public static PERMS_DATAFIELD = 'perms';
  constructor(private _sharedService: SharedService, private _router: Router, private _authService: AuthGuard) { }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._authService.loadSharedData()
      .then(() => {
        const activable = (!route.data[PermissionService.PERMS_DATAFIELD] || this.check(route.data[PermissionService.PERMS_DATAFIELD]));
        if (!activable) { this._router.navigate(['../']); }
        return activable;
      });
  }

  public check(perms: PermissionCheck): boolean {
    perms = perms || {};
    const readablePerms = (Array.isArray(perms.read) ? perms.read : [perms.read]).filter((p) => !!p); // check all entries with AND condition
    const writablePerms = (Array.isArray(perms.write) ? perms.write : [perms.write]).filter((p) => !!p); // check all entries with AND condition
    const rolePerms = (Array.isArray(perms.role) ? perms.role : [perms.role]).filter((p) => !!p); // check all entries in or condition
    const roleTypePerms = perms.roleType; // check all entries in or condition
    // all permissions match in or conditions
    if (
      (rolePerms.length > 0 && rolePerms.indexOf(_.get(this, '_sharedService.account.role')) === -1) || // checking by account role
      (writablePerms.length > 0 && writablePerms.filter((perm) => !this.isWritable(perm)).length > 0) || // checking if all write permissions are enabled
      (readablePerms.length > 0 && readablePerms.filter((perm) => !this.isReadable(perm)).length > 0) // checking if all read permissions are enabled
    ) {
      return false;
    }
    const userRoleType = _.get(this._sharedService, 'account.role_type') as UserRoleType;
    if (roleTypePerms && roleTypePerms.value && roleTypePerms.cond) {
      switch (roleTypePerms.cond) {
        case 'eq': return roleTypePerms.value === userRoleType;
        case 'neq': return roleTypePerms.value !== userRoleType;
        case 'in': return roleTypePerms.value.indexOf(userRoleType) > -1;
        case 'nin': return roleTypePerms.value.indexOf(userRoleType) < 0;
      }
    }
    return true;
  }

  public isReadable(perm: string): boolean {
    return this._sharedService.permission && this._sharedService.permission[perm] instanceof Permission ? this._sharedService.permission[perm].isReadable() : false;
  }
  public isWritable(perm: string): boolean {
    return this._sharedService.permission && this._sharedService.permission[perm] instanceof Permission ? this._sharedService.permission[perm].isWritable() : false;
  }
}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class GATrackerService {
  constructor(
    public window: Window,
  ) {

  }
  public trackEvent(eventConf: IGATrackerEventConfig) {
    // tslint:disable-next-line:curly
    if (!_.isFunction(this.window['gtag']))
      return console.warn('[GATracker] You need to install this https://developers.google.com/analytics/devguides/collection/gtagjs/#install_the_global_tracking_snippet');
    // tslint:disable-next-line:curly
    if (!eventConf.trackAction)
      return console.warn('[GATracker] Missing required "Action" parameter');

    eventConf.trackParams = eventConf.trackParams || {};
    // tslint:disable-next-line:curly
    if (!_.isFunction(eventConf.trackParams.event_callback))
      eventConf.trackParams.event_callback = (...args) => {
        // console.debug('[GATracker] args > ', args);
      };

    // console.debug('[GATracker] Tracking event action: %s params', eventConf.trackAction, eventConf.trackParams);
    this.window['gtag']('event', eventConf.trackAction, eventConf.trackParams);

  }
}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class GTMService {
  // tslint:disable-next-line:no-empty
  constructor(
    private _shared: SharedService
  ) { }

  get companySettings(): { [name: string]: any } {
    return this._shared.directopubConfig;
  }

  get dataLayer(): IGTMPayload[] {
    const { gtm } = this.companySettings;
    return gtm && gtm.id && window['dataLayer'] ? window['dataLayer'] : [];
  }
}
// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class FormService {
  // tslint:disable-next-line:no-empty
  constructor(
    private _shared: SharedService,
  ) {
  }

  public static get validators(): { [k: string]: ValidatorFn } {
    return {
      // url: (c: AbstractControl): ValidationErrors | null => /^(https?):[\/]{2}((?:[\d]{1,3}\.){3}[\d]{1,3}|(?:[a-zA-Z0-9\-_]+\.){1,}[a-zA-Z0-9]{2,})/.test(c.value) ? null : { malformed: true },
      url: Validators.pattern(/^(https?):[\/]{2}((?:[\d]{1,3}\.){3}[\d]{1,3}|(?:[a-zA-Z0-9\-_]+\.){1,}[a-zA-Z0-9]{2,})/),
      phone: Validators.pattern(/^\+?([-0-9\s\(\)\/]{7,})$/i),
      password: Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/)
    };
  }

  public toFormGroup(formInputs: Array<FormElementBase<any>>): FormGroup {
    const formGroupOpts: { [k: string]: FormControl } = {};

    for (const input of formInputs) {
      switch (true) {
        case input instanceof FormInput:
          formGroupOpts[input.key] = new FormControl({ value: input.value, disabled: input.disabled },
            Validators.compose([
              input.required ? Validators.required : null
            ]));
          break;
      }
    }
    return new FormGroup(formGroupOpts);
  }
}

@Injectable()
export class checkProperty implements CanActivate {

  constructor( private _api: ApiService, private _alert: AlertService ) { }
  
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    // console.log('AuthGuard checkProperty CanActivate')

    return this._api.get('campaign/manager', route.params.id, new URLSearchParams('filter=properties_id')).toPromise().then(
      campaign => this._api.get('directopub/properties', campaign.data[0].properties_id, new URLSearchParams('filter=status') ).toPromise()
        .then( properties => properties.data.length > 0 ? true : this._alert.error({ text: 'CAMPAIGNS.WARN.NO_PROPERTY' }).then( () => false ) )      
    ).catch(
      err => {
        console.error('AuthGuard checkProperty CanActivate', err.message)
        return false
      }
    )

  }

}

@Injectable()
export class checkPasswordAge implements CanActivateChild {
  constructor ( public sharedService: SharedService, public router: Router, public _api: ApiService  ) {}

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {    
        
    // if ( this.sharedService.account.role == 'advertiser' && state.url != '/profile' ) {
    if ( state.url != '/profile' ) {

      if ( this.sharedService.account.password_expired ) 
        this.router.navigate(['/profile'])
      else 
        return true
      
      // return this.sharedService.getPasswordAge().then(
      //   () => {    
      //     if ( this.sharedService.account.password_expired ) 
      //       this.router.navigate(['/profile'])
      //     else 
      //       return true          
      //   }
      // ).catch(
      //   err => {
      //     console.error(err.message,err.stack)
      //     return true
      //   }
      // )

    } else {
      return true
    }

    // if ( this.sharedService.account.role == 'advertiser' && state.url != '/profile' && this.sharedService.account.password_expired ) {
    //   this.router.navigate(['/profile'])    
    // } else {
    //   return true
    // }

  }
}

export const COMMON_SERVICE_PROVIDERS = [
  GATrackerService,
  GTMService,
  ApiService,
  AlertService,
  Select2Service,
  AuthGuard,
  checkProperty,
  checkPasswordAge,
  FormService,
  PermissionService,
  {
    // singleton of shared service
    provide: SharedService,
    useFactory: (router: Router, storageService: LocalStorageService, api: ApiService, translate: TranslateService) => SharedService.getInstance(router, storageService, api, translate),
    deps: [Router, LocalStorageService, ApiService, TranslateService]
  }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/service.ts